/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {Container, Grid} from '@material-ui/core'
import {useStyles} from './Styles'
import Logo from '../Logo'
import LanguageSwitcher from '../LanguageSwitcher'
import {md} from '../../utils/ResponsiveUtility'
import SocialIcons from './SocialIcons'
import {Sticky} from 'react-sticky'

const Header = () => {
  const classes = useStyles()
  const [width, setWidth] = React.useState(document.body.clientWidth)
  let DesktopAndUp = (width >= md)
  React.useEffect(() => {
    const getWidth = () => {
      setWidth(document.body.clientWidth)
    }
    window.addEventListener('resize', getWidth)
    return () => {
      window.removeEventListener('resize', getWidth)
    }
  }, [width])
  return (
    <Sticky topOffset={0}>
      {({style}) => (
        <header className={classes.header} id='header' style={style}>
          <Container maxWidth="lg">
            <Grid container justify='space-between'>
              <Grid item xs={12} md={5} lg={9} className={classes.headerIdentity}>
                <Logo/>
              </Grid>
              {DesktopAndUp && <Grid item xs={12} md={7} lg={3}>
                <div className={classes.headerQuickActions}>
                  <LanguageSwitcher/>
                  <SocialIcons/>
                </div>
              </Grid>}
            </Grid>
          </Container>
        </header>
      )}
    </Sticky>
  )
}

export default Header
